import Vue from 'vue'
import App from './App.vue'
import config from '@/api/common' //ajax请求
import http from '@/api/http.js' //ajax请求
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import wtsTools from '@/static/js/wtsTools.esm.min.js' //弹窗
import notice from '@/api/notice.js' //弹窗
import units from '@/api/units' //公共方法
import dic from '@/api/dic' //字典
import filter from '@/api/filter.js' //公共过滤器
import store from './store/index'
import router from './router'
import VueCookies from 'vue-cookies'
import Vue2OrgTree from 'vue2-org-tree'
import 'vue2-org-tree/dist/style.css';
import vueDragSelectPro from 'vue-drag-select-pro'
// 注意：一定要引入css样式
import 'vue-drag-select-pro/lib/vueDragSelectPro.css'
import loading from "@/components/commons/loading";
import noData from "@/components/commons/noData";
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import Vloading from '@/directive/loading'
import preventReClick from '@/directive/preventReClick'
import drag from '@/directive/drag'
import zoom from '@/directive/zoom'
import './less/index.less';
import int from '@/directive/int'
// import '@/mixin'
import 'vue-photo-preview/dist/skin.css'
//精灵图

import '@/static/sprite/scss/_sprite.scss'

// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
// import 'vue2-org-tree/dist/style.css';
Vue.component('loading', loading)
Vue.component('noData', noData)

init();
function init() {
  // Vue.use(Viewer, {
  //   defaultOptions: {
  //     zIndex: 9999
  //   }
  // })
  Vue.use(int)
  Vue.use(preventReClick)
  Vue.use(preview)
  Vue.use(Vloading)
  Vue.use(drag)
  Vue.use(zoom)
  Vue.use(preview)
  Vue.use(vueDragSelectPro)
  Vue.use(config)
  Vue.use(http)
  Vue.use(wtsTools.tools)
  Vue.use(wtsTools.regulars)
  Vue.use(ViewUI);
  Vue.use(notice)
  Vue.use(filter)
  Vue.use(units)
  Vue.use(Vue2OrgTree)
  Vue.use(VueCookies)

  Object.keys(filter).forEach(key => {
    Vue.filter(key, filter[key])
  })

  Vue.directive('title', {
    inserted: function (el, binding) {
      document.title = binding.value;
    },
    update: function (el, binding) {
      document.title = binding.value;
    }
  });
  // 将API方法绑定到全局
  Vue.prototype.$config = config;
  Vue.prototype.$http = http;
  Vue.prototype.$tools = wtsTools.tools;
  Vue.prototype.$units = units;
  Vue.prototype.$regulars = wtsTools.regulars;
  Vue.prototype.$notice = notice;
  Vue.prototype.$dic = dic;
  Vue.prototype.$cookie = VueCookies;
  Vue.prototype.$bus = new Vue()
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

